import React from 'react';

const CrossMark = () => (
  <svg
    width="11px"
    height="11px"
    viewBox="0 0 11 11"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-724.000000, -10769.000000)" fill="#000000">
        <g transform="translate(425.000000, 10570.000000)">
          <g transform="translate(281.000000, 24.000000)">
            <g transform="translate(15.200000, 172.000000)">
              <path d="M8.96486835,8.4 L13.4836967,3.88117169 C13.6376929,3.72717547 13.6397992,3.47216897 13.4838151,3.31618488 C13.3323929,3.16476265 13.0748778,3.16025383 12.9188283,3.31630334 L8.4,7.83513165 L3.88117169,3.31630334 C3.72717547,3.16230712 3.47216897,3.16020079 3.31618488,3.31618488 C3.16476265,3.46760711 3.16025383,3.72512218 3.31630334,3.88117169 L7.83513165,8.4 L3.31630334,12.9188283 C3.16230712,13.0728245 3.16020079,13.327831 3.31618488,13.4838151 C3.46760711,13.6352373 3.72512218,13.6397462 3.88117169,13.4836967 L8.4,8.96486835 L12.9188283,13.4836967 C13.0728245,13.6376929 13.327831,13.6397992 13.4838151,13.4838151 C13.6352373,13.3323929 13.6397462,13.0748778 13.4836967,12.9188283 L8.96486835,8.4 L8.96486835,8.4 Z" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default CrossMark;
